/**
 * Search in the fleet list: the whole fleet is loaded (a firma has tens of cars), so it is filtered on the client. Every typed word must
 * match something of the car — its plate (spaces and case ignored, like every SPZ search), its VIN, its make / model / version / colour,
 * its pobočka, category or tarif — with accents ignored, so "skoda" finds Škoda.
 */

import type { FleetEntry } from './api';

const bezDiakritiky = (s: string): string => s.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
const bezMezer = (s: string): string => bezDiakritiky(s).replace(/\s+/g, '');

/** What a word is looked up in, per car: the text fields (accents ignored) and the plate / VIN (spaces ignored too). */
function seno(e: FleetEntry): { text: string; kody: string } {
  const v = e.vozidlo;
  const text = bezDiakritiky(
    [v?.znacka_nazev, v?.model_nazev, v?.provedeni, v?.verze, v?.barva, e.pobocka_nazev, e.kategorie_nazev, e.tarif_nazev].filter(Boolean).join(' '),
  );
  return { text, kody: bezMezer(`${v?.spz ?? ''} ${e.vin}`) };
}

export function hledejVozy(fleet: readonly FleetEntry[], q: string): FleetEntry[] {
  const slova = q.trim().split(/\s+/).filter(Boolean);
  if (slova.length === 0) return [...fleet];
  return fleet.filter((e) => {
    const s = seno(e);
    return slova.every((w) => s.text.includes(bezDiakritiky(w)) || s.kody.includes(bezMezer(w)));
  });
}
